<template>
<div>
    <div class="blur-overlay" v-if="createEmployeeWizardOpened">
    </div>
    <b-row style="overflow: hidden;" v-bind:class="{blur: createEmployeeWizardOpened}">
        <b-col md="auto" class="employee-col" v-if="!loading">
            <!-- <div class="container content border-right" style="margin-top:-5px;"> -->
                <b-row style="margin:0px 10px 10px 10px;">
                    <b-col class="col-no-margin employee-active">
                        <b-row style="height:255px;">
                            <b-col class="col-no-margin">
                                <div id="employee-picture" class="picture" style="cursor:pointer;" v-on:mouseover="showImageUploadCircle = true" v-on:mouseleave="showImageUploadCircle = false" v-bind:style="{background: GetProfilePictureUrl(employee, 'large'), opacity: (loading ? '0' : '1')}" v-on:click="UploadImage(false)">
                                    <div class="inner-circle" v-if="!employee.employeePicture || showImageUploadCircle" style="cursor:pointer;">
                                        <i v-if="!employee.employeePicture" class="fas fa-plus" ></i>
                                        <i v-else class="fas fa-edit"></i>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="col-no-margin">
                                <div class="firstName">
                                    <input @blur="update('firstName')" @keydown.enter="update('firstName')" v-model="employee.firstName"/>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="col-no-margin">
                                <div class="lastName">
                                    <input @blur="update('lastName')" @keydown.enter="update('lastName')" v-model="employee.lastName"/>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="split-flat-margin-lr">
                    <b-col style="padding-top:12px;"></b-col>
                </b-row>
                <b-row>
                    <b-col style="padding-top:12px;">
                        <b-row v-if="employees.length > 10">
                            <b-col>
                                <div class="employee-name-filter">
                                    <div class="name-filter" style="transition: .2s">
                                        <i class="fas fa-search"></i>
                                        <input style="width: 100%;" v-model="nameFilter"/>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                        <div class="data-grid employee-list" v-bind:class="{withfilter: employees.length > 10}" v-bind:style="{opacity: (loading ? '0' : '1'), border: employees.length < 10? '1px solid #cccccc' : ''}">
                            <div class="content" v-bind:style="{display: (loading ? 'none' : 'inline-block')}">
                                <grid ref="grid" :headerEnabled="false" :header="gridData.header" :data="dataFiltered" :OnSelect="ChangeEmployee" :OnSelectRow="ChangeEmployee">

                                </grid>
                            </div>
                        </div>
                        </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row style="margin-top:4px;">
                    <b-col>
                        <div class="button small" @click="initNewEmployee();">
                            <div class="label">Mitarbeiter anlegen</div>
                        </div>
                    </b-col>  
                </b-row>
            <!-- </div> -->
        </b-col>
        
        <b-col v-if="employees.length > 0">
            <b-container fluid class="scrollbar-container-employeedata">
            <div class="employee-settings data-input" v-bind:style="{opacity: (loading ? '0' : '1')}">
                <b-row>
                    <b-col cols=12>
                        <b-tabs v-model="selectedTab" align="left" justified active-nav-item-class="md-tab-active">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="header tab-label">
                                        <div class="label">Stammdaten</div>
                                    </div>
                                </template>
                                <div class="content">
                                    <employeecoredata :uiData="uiData" :employee="employee" :spots="spots" :employeetypes="employeetypes" :employeerules="employeerules"></employeecoredata>
                                </div>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <div class="header tab-label">
                                        <div class="label">Arbeitsvertrag</div>
                                    </div>
                                </template>
                                <div class="content">
                                    <employeecontract 
                                        ref="employeecontract"
                                        :uiData="uiData" 
                                        :employee="employee" 
                                        :contract="employeeContract" 
                                        :pastContracts="pastEmployeeContracts" 
                                        :futureContracts="futureEmployeeContracts" 
                                        :contractFiles="contractFiles" 
                                        @contract-added="employeeContractAdded" 
                                        @file-added="contractFileAdded" 
                                        @contract-approved="contractApproved" 
                                        @contract-deleted="employeeContractDeleted"
                                        @contract-updated="employeeContractUpdated">
                                    </employeecontract>
                                </div>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <div class="header tab-label">
                                        <div class="label">Unterlagen</div>
                                        <div v-if="selectedTab==2" class="fa-stack add-right" v-on:click.stop="$refs.documents.selectFileForUploadFromParent()"> 
                                            <i class="fas fa-circle fa-stack-2x"></i> 
                                            <i class="fas fa-plus fa-stack-2x"></i> 
                                        </div>
                                    </div>
                                </template>
                                <div class="content">
                                    <employeedocuments ref="documents" :employeeId="employee.id" @contract-deleted="contractFileDeleted"></employeedocuments>
                                </div>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <div class="header tab-label">
                                        <div class="label">Planungsoptionen</div>
                                    </div>
                                </template>
                                <div class="content">
                                    <employeeplantype :employee="employee" :employeetype="employeeTypeForEmployee(employee)" :employeerules="employeeRulesForEmployee(employee)"></employeeplantype>
                                </div> 
                            </b-tab>
                        </b-tabs>
                    </b-col>
                </b-row>
                    
                <div v-if="loading" class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
                <dropdown v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i" />
            </div>
            </b-container>
        </b-col>
    </b-row>
    <br>
    <b-modal class="image-upload-modal" id="modal-image-upload" v-model="imageUploadModal" hide-footer hide-header>
        <div v-if="uploading" class="loading">
            <i class="fas fa-spinner"></i>
        </div>
        <div v-else style="text-align:center;">
            <vue-avatar
                :image=uploadedImage
                :width=480
                :height=480
                :rotation="rotation"
                :scale="scale"
                ref="vueavatar"
                @vue-avatar-editor:image-ready="onImageReady"
                >
            </vue-avatar>
            <br>
            <div v-if="hasImage" style="margin: 0px 48px 8px 48px;">
            <label>Zoom:</label>
            <input type="range" min=1 max=3 step=0.02 v-model="scaleStr"/>
            <div class="radio">
                <hr/>
                <label for="rotateLeft"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(-90deg);"></i></label>
                <input style="cursor:pointer;" type="radio" :checked="rotation == -90" v-model="rotation" name="rotationLeft" v-bind:value="rotationLeft"/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label for="rotateNone"><i class="fas fa-portrait" style="margin: 4px 8px;"></i></label>
                <input style="cursor:pointer;" type="radio" :checked="rotation == 0" v-model="rotation" name="rotationNone" v-bind:value="rotationNone"/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label for="rotateRight"><i class="fas fa-portrait" style="margin: 4px 8px; transform: rotate(90deg);"></i></label>
                <input style="cursor:pointer;" type="radio" :checked="rotation == 90" v-model="rotation" name="rotationRight" v-bind:value="rotationRight"/>
            </div>
            <br>
            <button class="button" v-on:click="saveClicked">Mitarbeiterfoto speichern</button>
            </div>
        </div>
    </b-modal>
    <b-modal size="employeewizard" ref="modal-createemployee" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true">
        <div class="wizard-popup">
            <b-row>
                <b-col>
                    <div class="header main">
                        <div class="label">Neuen Mitarbeiter anlegen</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-createemployee'); createEmployeeWizardOpened = false">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <div v-show="wizardPage == 1">
                <b-row>
                    <b-col>
                        <div class="maindata">
                            <div id="employee-picture" class="picture" style="cursor:pointer;" v-on:mouseover="showWizardImageUploadCircle = true" v-on:mouseleave="showWizardImageUploadCircle = false" v-bind:style="{background: 'var(--contrast-1) no-repeat center/cover  url('+newEmployeeProfilePictureBase64+')', opacity: (loading ? '0' : '1')}" v-on:click="UploadImage(true)">
                                <div class="inner-circle" v-if="!newEmployeeProfilePictureBase64 || showWizardImageUploadCircle" style="cursor:pointer;">
                                    <i v-if="!newEmployee.newEmployeeProfilePictureBase64" class="fas fa-plus" ></i>
                                    <i v-else class="fas fa-edit"></i>
                                </div>
                            </div>                            
                            <div class="namedata">
                                <div class="salutation">
                                    <div class="half left">
                                        <div class="third">
                                            <div class="label">Anrede</div>
                                        </div>
                                        <div @click="toggleInputPopup('gender')" class="third" style="z-index: 1000; margin-top:1px;">
                                            <searchbar id="wizard-gender" class="filters" ref="filtersGender" :searchbar="filtersGender"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="firstName" v-bind:style="{width: newEmployee.firstName && newEmployee.firstName != ''? '100% !important' : '145px !important'}">
                                    <input @focus="toggleInputPopup('firstName', false)" id="wizard-firstName" placeholder="Vorname" v-model="newEmployee.firstName"/>
                                </div>
                                <div class="lastName" v-bind:style="{width: newEmployee.lastName && newEmployee.lastName != ''? '100% !important' : '200px !important'}">
                                    <input @focus="toggleInputPopup('lastName', false)" id="wizard-lastName" placeholder="Nachname" v-model="newEmployee.lastName"/>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="full split-bottom">
                                <div class="fourth left">
                                    <div class="label">Stammposition</div>
                                </div>
                                <div @click="toggleInputPopup('spotId')" class="twofourths" style="z-index: 1001;">
                                    <searchbar id="wizard-spotId" class="filters" ref="filtersSpot" :searchbar="filtersSpot"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="half">
                                    <div class="label">SV Nummer</div>
                                </div>
                                <div class="half cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.socialsecurity)}">
                                    <input @focus="toggleInputPopup('socialsecurity', false)" id="wizard-socialsecurity" type="text" v-model="newEmployee.socialsecurity"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Geburtsdatum</div>
                                </div>
                                <div class="half cd-input">
                                    <input @input="toggleInputPopup('dob')" id="wizard-dob" type="date" v-model="dateOfBirth"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="half">
                                    <div class="label">Staatsbürger</div>
                                </div>
                                <div @click="toggleInputPopup('nationality')" class="half" style="z-index: 1000;">
                                    <searchbar id="wizard-nationality" class="filters" ref="filtersNationality" :searchbar="filtersNationality"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Bürgertyp</div>
                                </div>
                                <div @click="toggleInputPopup('citizenType')" class="half" style="z-index: 990;"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                                    <searchbar id="wizard-citizenType" class="filters" ref="filtersCitizen" :searchbar="filtersCitizen"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Mobil</div>
                                </div>
                                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.mobilephone)}">
                                    <input id="wizard-mobilephone" type="text" v-model="newEmployee.mobilephone"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="third left">
                                    <div class="label">Telefon</div>
                                </div>
                                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.homephone)}">
                                    <input id="wizard-homephone" type="text" v-model="newEmployee.homephone"/>
                                </div>
                            </div>
                            <div class="full">
                                <div class="sixth left">
                                    <div class="label">E-Mail</div>
                                </div>
                                <div class="fivesixths cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.email)}">
                                    <input @focus="toggleInputPopup('email', false)" id="wizard-email" type="text" v-model="newEmployee.email"/>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- popovers for missing data -->
                <b-popover custom-class="missing-input-popup" :show.sync="popupgender" :disabled="popupdisabled" target="wizard-gender" content="Bitte auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupfirstName" :disabled="popupdisabled" target="wizard-firstName" content="Vorname angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popuplastName" :disabled="popupdisabled" target="wizard-lastName" content="Nachname angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupspotId" :disabled="popupdisabled" target="wizard-spotId" content="Stammposition auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupsocialsecurity" :disabled="popupdisabled" target="wizard-socialsecurity" content="SV Nummer angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupdob" :disabled="popupdisabled" target="wizard-dob" content="Geburtsdatum angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupnationality" :disabled="popupdisabled" target="wizard-nationality" content="Staatsbürgerschaft auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupcitizenType" :disabled="popupdisabled" target="wizard-citizenType" content="Bürgertyp auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupemail" :disabled="popupdisabled" target="wizard-email" content="E-Mail angeben" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 2">
                <b-row>
                    <b-col>
                        <div class="picture small" v-bind:style="{background: '#e5e5e5 no-repeat center/cover  url('+newEmployeeProfilePictureBase64+')'}">
                        </div>
                        <div class="name-header">
                            <div class="firstName">
                                {{ newEmployee.firstName }}
                            </div>
                            <div class="lastName">
                                {{ newEmployee.lastName }}
                            </div>
                            <div class="email">
                                {{ newEmployee.email }}
                            </div>
                        </div>
                        <div class="full split-bottom">
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="half left">
                                <div class="full">
                                    <div class="header">
                                        <div class="label">Wohnadresse</div>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">Anschrift</div>
                                    </div>
                                    <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.address)}">
                                        <input @focus="toggleInputPopup('address', false)" id="wizard-address" type="text" v-model="newEmployee.address"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">PLZ</div>
                                    </div>
                                    <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.postalCode)}">
                                        <input @focus="toggleInputPopup('postalCode', false)" id="wizard-postalCode" type="text" v-model="newEmployee.postalCode"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">Stadt</div>
                                    </div>
                                    <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.city)}">
                                        <input @focus="toggleInputPopup('city', false)" id="wizard-city" type="text" v-model="newEmployee.city"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">Land</div>
                                    </div>
                                    <div @click="toggleInputPopup('country')" class="twothirds" style="z-index: 1000;">
                                        <searchbar id="wizard-country" class="filters" ref="filtersCountry" :searchbar="filtersCountry"/>
                                    </div>
                                </div>
                            </div>
                            <div class="half">
                                <div class="full">
                                    <div class="header">
                                        <div class="label">Bankverbindung</div>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">IBAN</div>
                                    </div>
                                    <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.iban)}">
                                        <input id="wizard-iban" type="text" v-model="newEmployee.iban"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="third">
                                        <div class="label">BIC</div>
                                    </div>
                                    <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newEmployee.bic)}">
                                        <input id="wizard-bic" type="text" v-model="newEmployee.bic"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- popovers for missing input data -->
                <b-popover custom-class="missing-input-popup" :show.sync="popupaddress" :disabled="popupdisabled" target="wizard-address" content="Anschrift angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popuppostalCode" :disabled="popupdisabled" target="wizard-postalCode" content="PLZ angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupcity" :disabled="popupdisabled" target="wizard-city" content="Stadt angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupcountry" :disabled="popupdisabled" target="wizard-country" content="Land angeben" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 3">
                <b-row>
                    <b-col>
                        <div class="picture small" v-bind:style="{background: '#e5e5e5 no-repeat center/cover  url('+newEmployeeProfilePictureBase64+')'}">
                        </div>
                        <div class="name-header">
                            <div class="firstName">
                                {{ newEmployee.firstName }}
                            </div>
                            <div class="lastName">
                                {{ newEmployee.lastName }}
                            </div>
                            <div class="email">
                                {{ newEmployee.email }}
                            </div>
                        </div>
                        <div class="full split-bottom">
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Daten vollständig</div>
                            </div>
                            <div class="full">
                                <div class="label">
                                    Die eingegebenen Daten sind vollständig, nach dem Speichern können Sie gleich mit der Erstellung des Arbeitsvertrages fortfahren.
                                </div>
                            </div>
                            <div class="full">
                        <div class="right">
                            <div class="button small" @click="wizardNext()">
                                <div class="label">Ohne Arbeitsvertrag speichern</div>
                            </div>
                        </div>
                    </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div v-show="wizardPage == 4" style="height: 200px;">
                <div class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
            <b-row>
                <b-col>
                    <div class="footer right">
                        <div v-if="wizardPage > 1" class="button next" v-bind:class="{disabled: wizardPage == 4}" @click="wizardPrev()">
                            <div class="label">Zurück</div>
                        </div>
                        <div class="button next" v-bind:class="{green: wizardPage == 3, disabled: wizardPage == 4}" @click="wizardNext(wizardPage == 3)">
                            <div class="label">{{ wizardPage >= 3? 'Speichern und Vertrag erstellen' : 'Weiter' }}</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            
        </div>
    </b-modal>
    <b-modal ref="modal-error" centered title="Fehler">
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ errorTitle }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                <span v-html="errorMessage"></span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button green right" @click="hideModal('modal-error')">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-info" centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ infoTitle }}</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1" style="text-align: left;">
                <div>
                <span v-html="infoMessage"></span>
                </div>
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button green right" @click="hideModal('modal-info')">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
</div>
</template>

<script>
import grid from '../uicomponents/grid.vue'
import dropdown from '../uicomponents/dropdown.vue'
import searchbar from '../uicomponents/searchbar.vue'
import employeecoredata from './EmployeeCoreData.vue'
import employeeplantype from './EmployeePlantype.vue'
import employeecontract from './EmployeeContract.vue'
import employeedocuments from './EmployeeDocuments.vue'
import Vue from 'vue'
import {VueAvatar} from 'vue-avatar-editor-improved'

export default {
    components: {
        grid,
        dropdown,
        searchbar,
        employeecoredata,
        employeeplantype,
        employeecontract,
        employeedocuments,
        VueAvatar
    },
    name: 'employeedata',
    computed: {
        dateOfBirth: {
            get: function(){
                var dateStr;
                if(this.newEmployee.dob){
                    dateStr = this.$helpers.extractDateString(this.newEmployee.dob);
                }
                return dateStr;
            },
            set: function(val){
                this.newEmployee.dob = val;
            }
        },
        employeeContract: {
            get: function(){
                return this.employeeContractForEmployee(this.employee);
            }
        },
        pastEmployeeContracts: {
            get: function(){
                return this.employeeContractsForEmployeeWithType(this.employee, 0);
            }
        },
        futureEmployeeContracts: {
            get: function(){
                return this.employeeContractsForEmployeeWithType(this.employee, 2);
            }
        },
    },
    data() {
        return {
            uiData: {},
            selectedTab: 0,
            uploading: false,
            scaleStr: "",
            scale: 1.0,
            rotation: 0.0,
            rotationLeft: -90,
            rotationNone: 0,
            rotationRight: 90,
            imageUploadModal: false,
            uploadedImage: '',
            hasImage: false,
            employees: [],
            employeeTypeMap: {},
            employeeRulesMap: {},
            employeeContractMap: {},
            spotMap: {},
            contractFiles: {},
            dataFiltered: [],
            loading: true,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            showImageUploadCircle: false,
            showWizardImageUploadCircle: false,
            scrolling: false,
            scrollTop: 150,
            collapseCoredata: true,
            collapsePlantype: true,
            collapseRules: true,
            collapseContract: false,
            collapseDocuments: true,
            dropdowns: [],
            imagecrops: [],
            nameFilter: '',
            gridData: {
                header: [{
                        label: '',
                        description: 'MD Employee Picture',
                        map: (i) => i.employeePicture !== null,
                        type: 'icon',
                        width: '50px',
                        enabled: true
                    },
                    {
                        label: 'Name',
                        map: (i) => i.firstName + ' ' + i.lastName,
                        type: 'text',
                        width: '220px',
                        enabled: true
                    }
                ],
                data: []
            },
            spots: [],
            employeetypes: [],
            employeerules: [],
            employee: Object,
            savedEmployee: Object,
            createEmployeeWizardOpened: false,
            wizardPage: 1,
            newEmployee: Object,
            newEmployeeProfilePicture: null,
            newEmployeeProfilePictureBase64: null,
            imageForNewEmployee: false,
            filtersCountry: {},
            itemsCountry: [],
            filtersCitizen: {},
            itemsCitizen: [],
            filtersNationality: {},
            itemsNationality: [],
            genderCodes: ['M','F'],
            countryMap: {},
            citizenTypeMap: {},
            filtersGender: {},
            itemsGender: [],
            units: [], 
            filtersSpot: {},
            errorTitle: '',
            errorMessage: '',
            infoTitle: '',
            infoMessage: '',
            popupdisabled: true,
            popupgender: false,
            popupfirstName: false,
            popuplastName: false,
            popupspotId: false,
            popupsocialsecurity: false,
            popupdob: false,
            popupnationality: false,
            popupcitizenType: false,
            popupemail: false,
            popupaddress: false,
            popuppostalCode: false,
            popupcity: false,
            popupcountry: false,
        }
    },
    watch: {
        scaleStr: function(val, oldVal) {
            this.scale = parseFloat(val);
        },
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
            this.dataFiltered.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1)
        }
    },
    props: {},
    created() {
        window.employeesettings = this;
        var settings = this;
    },
    mounted(){
        this.seconds = new Date().getTime() / 1000;
        let view = this;
        view.refresh();
        this.$store.watch(this.$store.getters.getStoreId, storeId => {
            if (view.$store.state.jwt != undefined && view.$store.state.storeId != undefined) {
                view.refresh();
            }
        })
    },
    updated() {
        if (this.employee && !this.employee.firstName && this.gridData && this.gridData.data && this.gridData.data[0]) {
            this.employee = this.gridData.data[0];
            this.employee.selected = true;
            //this.$el.querySelector('.firstName input').value = this.employee.public_display_upper_line;
            //this.$el.querySelector('.lastName input').value = this.employee.public_display_lower_line;
            this.$forceUpdate();
            if(this.$refs.grid != undefined) this.$refs.grid.$forceUpdate();
        }
    },
    destroyed() {
        var settings = this;
        //window.clearTimeout(this.dragWatch);
        //document.body.removeEventListener('keydown', this.ScrollKey);
        /*var list = document.querySelectorAll('.employee-settings *');
        for(var x in list)
            if(!isNaN(parseInt(x))) list[x].removeEventListener('mousedown', this.StopScroll);*/
        //document.body.removeEventListener('mousemove', this.WatchMouse);
        if (document.querySelector('#imgupload')) document.querySelector('#imgupload').removeEventListener('change', settings.ProcessImageUpload);
        if (document.querySelector('#imguploadpublic')) document.querySelector('#imguploadpublic').removeEventListener('change', settings.ProcessImageUploadPublic);
        //document.body.removeEventListener('wheel', this.Scroll);
    },
    methods: {
        refresh(employeeIdToSelect = null){
            this.employee = {};
            this.loadUIData();
            this.RetrieveStoreEmployees(employeeIdToSelect);
            this.loadEmployeeContracts();
            this.loadEmployeeTypes();
            this.loadEmployeeRules();
            this.loadSpots();
        },
        onImageReady(){
            this.scaleStr = "1";
            this.rotation = 0;
            this.hasImage = true;
        },
        saveClicked(){
            var view = this;
            var img = this.$refs.vueavatar.getImageScaled();
            var urlString = img.toDataURL();
            var seconds = new Date().getTime() / 1000;
            var imgFile = this.$helpers.dataURLtoFile(urlString, 'profile_picture_' + seconds + '.jpg');
            if(this.imageForNewEmployee){
                this.newEmployeeProfilePicture = imgFile;
                this.newEmployeeProfilePictureBase64 = urlString;
                this.uploading = false;
                this.hasImage = false;
                this.imageUploadModal = false;
                this.uploadedImage = null;
                requestAnimationFrame(function () {
                    view.$forceUpdate();
                });
            }else{
                this.uploading = true;
                this.setEmployeePicture(this.employee.id, imgFile).then((result) => {
                    if(view.employee != undefined){
                        view.employee.employeePicture = result.data.data;
                    }
                    for(var i = 0; i < view.employees.length; i++){
                        if(view.employees[i].id == view.employee.id){
                            view.employees[i].employeePicture = result.data.data;
                        }
                    }
                    for(var i = 0; i < view.dataFiltered.length; i++){
                        if(view.dataFiltered[i].id == view.employee.id){
                            view.dataFiltered[i].employeePicture = result.data.data;
                        }
                    }
                    view.seconds = new Date().getTime() / 1000;
                    view.uploading = false;
                    view.hasImage = false;
                    view.imageUploadModal = false;
                    view.uploadedImage = null;
                    requestAnimationFrame(function () {
                        view.$forceUpdate();
                    });
                }).catch(error2 => {
                    view.uploading = false;
                    view.hasImage = false;
                    view.imageUploadModal = false;
                    view.uploadedImage = null;
                    console.log(error2);
                });
            }
        },
        RetrieveStoreEmployees(employeeIdToSelect = null) {
            var app = this;
            this.loading = true;

            let url = '/api/sec/employee';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then((result) => {
                app.loading = false;
                var processed = [];
                if (result.data) {
                    app.employees = result.data;
                    app.employees.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1);
                    app.gridData.data = app.employees;
                    app.dataFiltered = app.gridData.data.slice();
                    app.dataFiltered.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1);
                    if (result.data.length > 0) {
                        if(employeeIdToSelect){
                            for(var i = 0; i < app.employees.length; i++){
                                if(app.employees[i].id == employeeIdToSelect) app.employee = app.employees[i];
                            }
                        }else{
                            app.employee = app.employees[0];
                        }
                        app.savedEmployee = Object.assign({}, app.employee);
                        app.employee.selected = true;
                    }
                    requestAnimationFrame(function () {
                        app.$forceUpdate();
                    });
                }
            });
        },
        loadEmployeeTypes: function () {
            let url = '/api/sec/employeetype?storeId=' + this.$store.state.storeId;
            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                this.updateEmployeeTypes(response.data);
            });

        },
        updateEmployeeTypes: function (data) {
            var i;
            let ttypes = {}
            var typesArray = [];
            for (i = 0; i < data.length; i++) {
                var item = data[i];
                typesArray.push({id: item.id, name: item.name, label: item.name});
                ttypes[item.id] = item;
            }
            this.employeeTypeMap = ttypes;
            this.employeetypes = typesArray;
           
            
        },
        loadEmployeeRules: function () {
            let url = '/api/sec/employeerules';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                this.updateEmployeeRules(response.data);
            });
        },
        updateEmployeeRules: function (data) {
            var i;
            let trules = {}
            var rulesArray = [];
            for (i = 0; i < data.length; i++) {
                var item = data[i];
                rulesArray.push({id: item.id, name: item.name, label: item.name});
                trules[item.id] = item;
            }
            this.employeeRulesMap = trules;
            this.employeerules = rulesArray;
        },
        loadEmployeeContracts : function(employeeId) {
            let url = '/api/sec/employeecontract';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
            if(employeeId != undefined){
                url = this.$helpers.appendParam("employeeId", employeeId, url, '/api/sec/employeecontract'); 
            }
            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                this.updateEmployeeContracts(response.data);
                this.loadContractFiles(response.data);
            }).catch(function (error) {
                console.log(error)
            });
        },
        updateEmployeeContracts: function(data){
            var i;
            let tcontracts = {}
            for (i = 0; i < data.length; i++) {
                tcontracts[data[i].id] =data[i];
            }
            this.employeeContractMap = tcontracts;
        },
        loadContractFiles(contracts){
            for(var i = 0; i < contracts.length; i++){
                var contract = contracts[i];
                if(contract.fileId){
                    let fileId = contract.fileId;
                    let view = this;
                    let url = '/api/sec/employeefile';

                    url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                    url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                    this.axios({
                        method: 'get',
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url
                    }).then((response)=>{
                        var f = response.data;
                        this.contractFiles[f.id] = f;
                    });
                }
            }
        },
        loadSpots : function() {
            let url = '/api/sec/spot';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                this.updateSpots(response.data);
            }).catch(function (error) {
                console.log(error)
            });
        },
        updateSpots: function(data){
            var i;
            let tspots = {};
            var spotsArray = [];
            for (i = 0; i < data.length; i++) { 
                let item = {
                    id: data[i].id,
                    name: data[i].name,
                    label: data[i].name
                }
                tspots[item.id] = item;
                spotsArray.push(item);
            }
            this.spotMap = tspots;
            this.spots = spotsArray;
        },
        loadUIData: function(){
            let url = '/api/semi/uidata';
            let view = this;
            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                view.uiData = response.data;
                view.uiData.countries.forEach(item => this.countryMap[item.id] = item.label_de);
                view.uiData.citizenTypes.forEach(item => this.citizenTypeMap[item.id] = item.label_de);
            });
        },
        employeeTypeForEmployee(employee) {
            var type = this.employeeTypeMap[employee.typeId];
            return type;
        },
        employeeRulesForEmployee(employee) {
            var rules = this.employeeRulesMap[employee.ruleId];
            if (rules) {
                return rules.rules;
            }
            return rules;
        },
        employeeContractForEmployee(employee){
            var contract;
            var keys = Object.keys(this.employeeContractMap);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if(this.employeeContractMap[key].employeeId == employee.id) {
                    if(this.contractType(this.employeeContractMap[key]) == 1){
                        contract = this.employeeContractMap[key];
                    }
                }
            }
            return contract;
        },
        employeeContractsForEmployeeWithType(employee, type){
            var c = [];
            var keys = Object.keys(this.employeeContractMap);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if(this.employeeContractMap[key].employeeId == employee.id){
                    let contract = this.employeeContractMap[key];
                    if(this.contractType(contract) == type) c.push(contract);
                }
            }
            return c;
        },
        contractType(c){
            var now = new Date();
            let fromDate = new Date(c.from);
            if(c.to){
                let toDate = new Date(c.to);
                if(toDate < now){
                    return 0;
                }
            }
            if(fromDate < now) return 1;
            if(fromDate > now) return 2;
            return -1;
        },
        employeeContractAdded(contract){
            this.employeeContractMap[contract.id] = contract;
            this.$forceUpdate();
            this.refresh(this.employee.id);
        },
        employeeContractUpdated(contract){
            this.employeeContractMap[contract.id] = contract;
            this.$forceUpdate();
            this.refresh(this.employee.id);
        },
        employeeContractDeleted(contractId){
            delete this.employeeContractMap[contractId];
            this.$forceUpdate();
            this.refresh(this.employee.id);
        },
        contractFileAdded(contractId, contractFile){
            var c = this.employeeContractMap[contractId];
            c.fileId = contractFile.id;
            var docs = this.$refs.documents;
            docs.refresh();
        },
        contractFileDeleted(fileId){
            var keys = Object.keys(this.employeeContractMap);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if(this.employeeContractMap[key].fileId == fileId){
                    this.unlinkContractFile(this.employeeContractMap[key].id);
                }
            }
        },
        contractApproved(contractId){
            this.employeeContractMap[contractId].approved = true;
            this.refresh();
        },
        unlinkContractFile(contractId){
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
            url = this.$helpers.appendParam("employeeId", this.employee.id, url, '/api/sec/employeecontract');

            let payload = {
                id: contractId,
                fileId: "",
                approved: false,
                approvedBy: "",
                approvalDate: "",
                updateFields: ["fileId", "approved", "approvedBy", "approvalDate"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.employeeContractMap[contractId].fileId = null;
                view.employeeContractMap[contractId].approved = false;
                delete view.employeeContractMap[contractId].approvedBy;
                delete view.employeeContractMap[contractId].approvalDate;
                view.$forceUpdate();
                view.$refs.employeecontract.$forceUpdate();
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            });
        },
        SelectNextEmployee() {
            for (var x in this.gridData.data) {
                this.gridData.data[x].selected = false;
            }

            this.employee = this.$refs.grid.data[(this.$refs.grid.data.indexOf(this.employee) + this.$refs.grid.data.length + 1) % this.$refs.grid.data.length];
            this.employee.selected = true;
            //this.$el.querySelector('.firstName input').value = this.employee.public_display_upper_line;
            //this.$el.querySelector('.lastName input').value = this.employee.public_display_lower_line;
            this.$forceUpdate();
            this.$refs.grid.$forceUpdate();
        },
        SelectPreviousEmployee() {
            for (var x in this.gridData.data) {
                this.gridData.data[x].selected = false;
            }

            this.employee = this.$refs.grid.data[(this.$refs.grid.data.indexOf(this.employee) + this.$refs.grid.data.length - 1) % this.$refs.grid.data.length];
            this.employee.selected = true;
            //this.$el.querySelector('.firstName input').value = this.employee.public_display_upper_line;
            //this.$el.querySelector('.lastName input').value = this.employee.public_display_lower_line;
            this.$forceUpdate();
            this.$refs.grid.$forceUpdate();
        },
        UploadImage(forNewEmployee) {
            this.imageForNewEmployee = forNewEmployee;
            this.imageUploadModal = true;
        },
        OnEnter(itemHeader, item) {
            if (itemHeader.OnEnter !== null) {
                itemHeader.OnEnter(item);
            }
        },
        ToggleEdit($event, className) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
            $event.currentTarget.classList.toggle('edit');
            $event.currentTarget.childNodes[1].value = '';
            $event.currentTarget.childNodes[1].focus();
        },
        EndEdit($event) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
        },
        ToggleClassParent($event, className) {
            $event.currentTarget.parentNode.classList.toggle(className);
        },
        GetGridOptions() {
            var options = [];
            for (var x in this.gridData.header) {
                var option = this.gridData.header[x];
                options.push({
                    label: option.label,
                    description: option.description,
                    type: 'bool',
                    toggle: option.enabled,
                    option: option,
                    onceSelected: function ($eventInner, item, dropdown) {
                        dropdown.toggled = false;
                        item.option.enabled = !item.option.enabled;
                    }
                });
            }
            return options;

        },
        StopScroll($event) {
            if ($event.which === 2) {
                this.ScrollWheelClick($event);
                $event.preventDefault();
                return;
            }
            this.scrolling = false;
        },

        ScrollKey($event) {
            var event = $event;
            var keyName = event.key;
            if (document.body.querySelectorAll('.modal').length > 0) return;

            // As the user releases the Ctrl key, the key is no longer active,
            // so event.ctrlKey is false.
            if (keyName === 'PageUp') {
                this.scrollTop += document.documentElement.clientHeight - 50;
            }
            if (keyName === 'PageDown') {
                this.scrollTop -= document.documentElement.clientHeight - 50;
            }
            if (this.scrollTop > 150) this.scrollTop = 150;
            var box = this.$el.getBoundingClientRect();
            if (this.scrollTop < -1 * (box.height - (window.innerHeight))) this.scrollTop = -1 * (box.height - (window.innerHeight));
        },
        Scroll($event) {
            var event = $event;

            if (document.body.querySelectorAll('.modal').length > 0) return;
            this.scrollTop += -$event.deltaY / 2.5;
            if (this.scrollTop > 150) this.scrollTop = 150;
            var box = this.$el.getBoundingClientRect();
            if (this.scrollTop < -1 * (box.height - (window.innerHeight))) this.scrollTop = -1 * (box.height - (window.innerHeight));
        },
        WatchMouse($event) {
            this.mouseCurrent = {
                x: $event.clientX,
                y: $event.clientY
            };
        },
        WatchDrag($event) {
            if (!this.scrolling) return;
            this.scrollTop -= (this.mouseCurrent.y - this.mouseDragStart.y) / 10;
            if (this.scrollTop > 150) this.scrollTop = 150;
        },
        ScrollWheelClick($event) {
            var event = $event;
            this.scrolling = !this.scrolling;
            this.mouseDragStart = this.mouseCurrent;
        },
        GetProfilePictureUrl(employee, size=null) {
            if(employee.employeePicture == null){
                return 'var(--contrast-1) no-repeat center/cover url(/img/avatar.png)';
            } else {
                var imgUrl = employee.employeePicture.server+"/api/file?id="+employee.employeePicture.fileId+"&accessToken="+employee.employeePicture.accessToken+'&s='+this.seconds;
                if(size) imgUrl = imgUrl + '&thumb=' + size;
                return 'var(--contrast-1) no-repeat center/cover  url('+ imgUrl+')'; 
            }
        },
        setEmployeePicture(employeeId, profilePictureFile){
            let view = this;
            let url = '/api/sec/employee/picture';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/picture');
            let formData = new FormData();
            formData.append("employeeId", employeeId);
            formData.append('file', profilePictureFile);

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt,
                    'Content-Type': 'multipart/form-data'
                },
                url: url,
                data: formData
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Setzen des Profilbildes"})
            )
        },
        UpdateEmployee(employee, data) {
            var form = new FormData();
            var temp = {
                k: employee.id,
                v: data.value,
                c: data.field
            };
            for (var x in temp) form.append(x, temp[x]);
            this.$http.post('employees/update', form).then(function (response) {
                this.employee = response.data.data;
                this.$forceUpdate();
            });
            this.imagecrops = [];
        },
        ChangeEmployee(employee) {
            for (var x in this.gridData.data) {
                this.gridData.data[x].selected = false;
            }

            this.employee = employee;
            this.savedEmployee = Object.assign({}, this.employee);
            this.employee.selected = true;
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety) {
            var event = $event;
            var box = event.currentTarget.getBoundingClientRect();
            var dropdowns = this.dropdowns;
            this.dropdowns.push({
                items: selection,
                el: event.currentTarget,
                remainAfterSelect: true,
                toggled: true,
                offsetx: offsetx,
                offsety: offsety,
                posx: box.left + offsetx,
                posy: box.bottom + offsety,
                onceSelected: function ($eventInner, item, dropdown) {
                    var eventInner = $eventInner;
                    var boxInner = eventInner.currentTarget.getBoundingClientRect();
                    var temp = {
                        items: item.items,
                        //el: event.currentTarget,
                        offsetx: offsetx + 130,
                        offsety: offsety,
                        posx: box.left + offsetx + 130,
                        toggled: true,
                        posy: boxInner.bottom - 30,
                        pointerDirection: 3,
                        parentCallback: function () {
                            dropdown.toggled = false
                        }
                    };
                    dropdowns.push(temp);
                }
            });
        },
        
        Init(items, config) {},
        // DATA UPDATE METHODS
        update(key, isDate=false){
            if(this.savedEmployee[key] != this.employee[key]){
                let view = this;
                if(key == 'spotId'){
                   
                    let url = '/api/sec/employee/linkspot';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                    let payload =  {
                        id: this.employee.id,
                        spotId: this.employee.spotId,
                        deleteOldSkill: true,
                        skillValue: 10,
                    }

                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        view.savedEmployee.spotId = view.employee.spotId;
                    }).catch(function (error) {
                        console.log(error)
                    })
                } else {
                    let url = '/api/sec/employee';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
                    let payload = {
                        'id': this.employee.id,
                        'updateFields':[key],
                        [key]: (isDate? this.$helpers.convertDateTimeString(this.employee[key]) : this.employee[key])
                    }
                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {  
                        this.savedEmployee[key] = this.employee[key];
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
                
                
            }
        },
        updateNationalityDropdown(){
            var view = this;
            this.itemsNationality = [];
            // dropdown data country
           
            for(const val of this.uiData.countries){
                this.itemsNationality.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersNationality = {
                toggled: false,
                displayedItems: this.itemsNationality,
                input: this.newEmployee.nationality != undefined? this.countryMap[this.newEmployee.nationality] : 'bitte wählen',
                items: Object.values(this.itemsNationality),
                onceSelected: function ($event, item, searchbar){
                    view.newEmployee.nationality = item.code;
                    view.toggleInputPopup('nationality', false);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateCountryDropdown(){
            var view = this;
            this.itemsCountry = [];
            // dropdown data country
            for(const val of this.uiData.countries){
                this.itemsCountry.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersCountry = {
                toggled: false,
                displayedItems: this.itemsCountry,
                input: this.newEmployee.country != undefined? this.countryMap[this.newEmployee.country] : 'bitte wählen',
                items: Object.values(this.itemsCountry),
                onceSelected: function ($event, item, searchbar){
                    view.newEmployee.country = item.code;
                    view.toggleInputPopup('country', false);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateCitizenTypeDropdown(){
            var view = this;
            this.itemsCitizen = [];
            // dropdown data citizenType
            for(const val of this.uiData.citizenTypes){
                this.itemsCitizen.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersCitizen = {
                toggled: false,
                displayedItems: this.itemsCitizen,
                input: this.newEmployee.citizenType != undefined? this.citizenTypeMap[this.newEmployee.citizenType] : 'bitte wählen',
                items: Object.values(this.itemsCitizen),
                onceSelected: function ($event, item, searchbar){
                    view.newEmployee.citizenType = item.code;
                    view.toggleInputPopup('citizenType', false);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateSalutationDropdown(){
            var view = this;
            this.itemsGender = [];
            // dropdown data country
            for(const val of this.genderCodes){
                this.itemsGender.push({code: val, label: this.$helpers.salutation(val), name: this.$helpers.salutation(val)});
            }
            this.filtersGender = {
                toggled: false,
                displayedItems: this.itemsGender,
                input: this.newEmployee.gender != undefined? this.$helpers.salutation(this.newEmployee.gender) : '',
                items: Object.values(this.itemsGender),
                onceSelected: function ($event, item, searchbar){
                    view.newEmployee.gender = item.code;
                    // view.newEmployee.salutation = item.name; // is there something like a field 'Anrede'?
                    view.toggleInputPopup('gender', false);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateSpotsDropdown(){
            var view = this;
            // dropdown data spots
            this.filtersSpot = {
                toggled: false,
                displayedItems: this.spots,
                input: this.newEmployee.spotId != undefined? this.spotMap[this.employee.spotId].label : 'bitte wählen',
                items: Object.values(this.spots),
                onceSelected: function ($event, item, searchbar){
                    console.log("Spot ID: " + item.id);
                    view.newEmployee.spotId = item.id;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        inheritedSearchbarStyle(el) {
            $(el).find('.entry').css({
                'width': '100%',
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'height': '18px',
                'padding': '0px 1px',
                'color': 'var(--contrast-3)',
            });
            $(el).find('.fa-stack').css({
                'top': '0px',
                'margin-top': '0px',
                'margin-right': '4px',
                'right': '0px'
            });
            $(el).find('input').css({
                'box-shadow': 'none',
                'background': 'none'
            });
            $(el).find('.fa-angle-down').css({
                'color': '#ffffff'
            });
            $(el).find('.fa-circle').css({
                'color': 'var(--contrast-2)'
            });
            $(el).find('.items').css({
                position: 'absolute',
                top: '19px',
                left: '-1px',
                width: 'calc(100% + 2px)',
                'box-shadow': 'none',
            });
            $(el).find('.items .item:even').css({
                background: 'var(--contrast-1)'
            });
            $(el).find('.items .item:odd').css({
                background: 'var(--bg)'
            });
            $(el).find('.items .item').css({
                padding: '4px 0px 4px 4px'
            });
            $(el).find('.item .label').css({
                color: 'var(--contrast-5)',
                'font-size': '10px',
                'margin-top': '0px'
            });
        },
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        initNewEmployee(){
            this.newEmployee = {
                spotId: null,
                typeId: null,
                ruleId: null,
                title: "",
                prefix: "",
                firstName: undefined,
                postfix: "",
                lastName: undefined,
                dob: null,
                gender: undefined,
                religion: "",
                socialsecurity: null,
                disability: false,
                driverslicense: false,
                dlExpiry: null,
                firstaidcourse: false,
                faExpiry: null,
                mobilephone:"",
                homephone: "",
                email: null,
                country: 0,
                address: undefined,
                postalCode: undefined,
                city: undefined,
                iban: "",
                bic: "",
                nationality: 0,
                citizenType: 0,
                employedSince: null,
                guardianName: "",
                guardianAddress: "" 
            }
            this.newEmployeeProfilePicture = null;
            this.newEmployeeProfilePictureBase64 = null;
            this.updateSalutationDropdown();
            this.updateNationalityDropdown();
            this.updateCountryDropdown();
            this.updateCitizenTypeDropdown();
            this.updateSpotsDropdown();
            this.wizardPage = 1;
            this.createEmployeeWizardOpened = true;
            this.showModal('modal-createemployee');
        },
        checkEmployeeWizardData(){
            var em = this.newEmployee;
            var params = null;
            var ready = true;
            var missing = []
            switch(this.wizardPage){
                case 1:
                    if(this.$helpers.isEmpty(em.gender)) missing.push({key: 'gender', label: 'Anrede'});
                    if(this.$helpers.isEmpty(em.firstName)) missing.push({key: 'firstName', label: 'Vorname'});
                    if(this.$helpers.isEmpty(em.lastName)) missing.push({key: 'lastName', label: 'Nachname'});
                    if(this.$helpers.isEmpty(em.spotId)) missing.push({key: 'spotId', label: 'Stammposition'});
                    if(this.$helpers.isEmpty(em.socialsecurity)) missing.push({key: 'socialsecurity', label: 'Sozialversicherungsnummer'});
                    if(this.$helpers.isEmpty(em.dob)) missing.push({key: 'dob', label: 'Geburtsdatum'});
                    if(em.nationality == 0) missing.push({key: 'nationality', label: 'Staatsbürgerschaft'});
                    if(em.citizenType == 0) missing.push({key: 'citizenType', label: 'Bürgertyp'});
                    if(this.$helpers.isEmpty(em.email)) missing.push({key: 'email', label: 'E-Mail'});
                    break;
                case 2:
                    if(this.$helpers.isEmpty(em.address)) missing.push({key: 'address', label: 'Anschrift'});
                    if(this.$helpers.isEmpty(em.postalCode)) missing.push({key: 'postalCode', label: 'Postleitzahl'});
                    if(this.$helpers.isEmpty(em.city)) missing.push({key: 'city', label: 'Stadt'});
                    if(em.country == 0) missing.push({key: 'country', label: 'Land'});
                    break;
            }
            return missing;
        },
        toggleInputPopup(key, show){
            this.popupdisabled = false;
            switch(key){
                case 'gender':
                    this.popupgender = show;
                    break;
                case 'firstName':
                    this.popupfirstName = show;
                    break;
                case 'lastName':
                    this.popuplastName = show;
                    break;
                case 'spotId':
                    this.popupspotId = show;
                    break;
                case 'socialsecurity':
                    this.popupsocialsecurity = show;
                    break;
                case 'dob':
                    this.popupdob = show;
                    break;
                case 'nationality':
                    this.popupnationality = show;
                    break;
                case 'citizenType':
                    this.popupcitizenType = show;
                    break;
                case 'email':
                    this.popupemail = show;
                    break;
                case 'address':
                    this.popupaddress = show;
                    break;
                case 'postalCode':
                    this.popuppostalCode = show;
                    break;
                case 'city':
                    this.popupcity = show;
                    break;
                case 'country':
                    this.popupcountry = show;
                    break;
            }
            this.popupdisabled = true;
        },
        wizardPrev(){
            if(this.wizardPage > 1) this.wizardPage = this.wizardPage - 1;
        },
        wizardNext(proceedWithContract = false){
            var missing = this.checkEmployeeWizardData();
            if(missing.length == 0){
                // data complete for current page
                this.wizardPage = this.wizardPage + 1;
                if(this.wizardPage == 4){
                    // create employee
                    this.createEmployee(proceedWithContract);
                }
            }else{
               this.toggleInputPopup(missing[0].key, true);
            }
        },
        createEmployee(proceedWithContract = false){
            this.employeeerror=false;
            let view = this;
            let url = '/api/sec/employee';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
            url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employee');
            
            let payload = {
            storeId: this.$store.state.storeId,
            }
            
            for (var property in this.newEmployee) {
                if(!this.$helpers.isBlank(this.newEmployee[property])){
                    payload[property] = this.newEmployee[property];
                } else {
                    payload[property] = null;
                }
                
            }
            payload.dob = this.$helpers.convertDateTimeString(this.newEmployee.dob);
            payload.dlExpiry = this.$helpers.convertDateTimeString(this.newEmployee.dlExpiry);
            payload.faExpiry = this.$helpers.convertDateTimeString(this.newEmployee.faExpiry);
            
            console.log(payload);
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                var employee = response.data.data;
                view.employees.push(employee);
                if(view.newEmployeeProfilePicture != null){
                    //set employee picture
                    this.setEmployeePicture(employee.id, this.newEmployeeProfilePicture)
                    .then(response2=>{
                        employee.employeePicture = response2.data.data;
                        view.employeePicture = null;
                        view.createEmployeeWizardOpened = false;
                        view.hideModal('modal-createemployee');
                        view.refresh(employee.id);
                        if(proceedWithContract){
                            view.$refs.employeecontract.openNewContractWizard();
                        }
                    }).catch(error2 => {
                        view.employeePicture = null;
                        console.log(error2);
                        view.createEmployeeWizardOpened = false;
                        view.hideModal('modal-createemployee');
                        view.refresh(employee.id);
                    })
                } else {
                    view.createEmployeeWizardOpened = false;
                    view.hideModal('modal-createemployee');
                    view.refresh(employee.id);
                    if(proceedWithContract){
                        view.$refs.employeecontract.openNewContractWizard();
                    }
                }
                
            }).catch(function (error) {
                view.employeeerror=true;
                console.log(error)
            });
        },
        infoPopup(title, message){
            this.infoTitle = title;
            this.infoMessage = message;
            this.showModal('modal-info');
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.searchbar.filters {
    height: 18px !important;
    display: block;
    margin-top: 4px;
    width: 100%;
}
</style>
